import React from 'react';
import cx from 'classnames';

import Text from '../Text';

import styles from './StatusChip.module.scss';
import usePresenter from './StatusChip.presenter';
import getProps from './StatusChip.props';
import { StatusChipCombinedProps } from './types';

const StatusChip: React.FC<StatusChipCombinedProps> = (props) => {
  const {
    state,
    className,
    classes,
    text,
  } = usePresenter(props);

  const variantName = `${state}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`statusChip${variantName}`];

  let componentView;

  switch (variantName) {
    case 'Default':
    case 'Error':
    case 'Success': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default StatusChip;
